import { ModalBase } from "../../../../components/Modals/ModalBase"
import InputForm from "../InputFormV2"

import HelpIcon from '../../../../media/felsv/help-circle-svgrepo-com.svg';
import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import { useEffect } from "react"
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto"
import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import useUtilsDocs, { esCatalogoProductoByTipo, formatearNum } from "../../../../actions/utils-documentos.actions"
import { Tooltip } from "../../../../components/Tooltip/Tooltip"
import InputSwitchDescripcion, { CheckBoxFlag } from "../InputSwitchDescripcion";
import { REGEX_HTML } from "../../../../constants/Regex";

export default function ModalEditarProducto (props: any) {
    const {unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos);
    const {processOtrosImpuestosCalculo} = useUtilsDocs();

    const {formProducto, onChangeFormProducto, onChangeSelectCatalogoProducto, onClickCerrarModalEditarProducto, onClickActualizarProducto, errors} = props;
    const esHtmlDescripcion = REGEX_HTML.test(formProducto.descripcion);
    
    let precioUnitario = formProducto.conIva ? parseFloat(formProducto.precio)/1.13 : parseFloat(formProducto.precio)
    let descuento = 0
    if(formProducto.tipoDescuento === 'Porcentaje'){
        descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : (precioUnitario * parseFloat(formProducto.descuento)/100) * parseFloat(formProducto.cantidad)
    } else {
        descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : parseFloat(formProducto.descuento)
    }
    if(props.facturaExportacion){
        precioUnitario = parseFloat(formProducto.precio || '0')
    }
    let neto = (parseFloat(formProducto.cantidad) * precioUnitario);
    let subtotal = neto - descuento;
    let iva = subtotal * 0.13;
    let otrosImpuestos = processOtrosImpuestosCalculo(props.dteCode, formProducto, subtotal);

    if(formProducto.exento || formProducto.noSujeto || formProducto.noGravado || props.facturaExportacion) iva = 0;

    let total = subtotal + iva;

    const mostrarNoGravadoNoSujeto = props.dteCode === '03' || props.dteCode === '05'

    useEffect(() => {
        if(formProducto.exento){
            onChangeFormProducto('conIva', false)
        }
    }, [formProducto.exento])

    useEffect(() => {
        if(formProducto.conIva){
            onChangeFormProducto('exento', false)
            onChangeFormProducto('noSujeto', false)
            onChangeFormProducto('noGravado', false)
        }
    }, [formProducto.conIva])

    useEffect(() => {
        if(formProducto.noSujeto || formProducto.noGravado){
            onChangeFormProducto('conIva', false)
        }
    }, [formProducto.noSujeto, formProducto.noGravado])

    return (
        <ModalBase>
            <div className="cf-modal-container">
            <label className="cf-section-title">{formProducto.servicio ? 'Servicio' : 'Producto'}</label>
                <hr className="separador"/>
                <div style={{display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '20px'}}>
                    {!props.desactivarSwitch &&
                        <SwitchTipoProductoDTE disabled = {props.notaRemision} producto = {!formProducto.servicio} setProducto = {() => onChangeFormProducto('servicio', false)} setServicio = {() => onChangeFormProducto('servicio', true)}/>
                    }
                    
                {!props.facturaExportacion &&
                    <>
                    {!props.desactivarExento &&
                        <InputForm required name = 'exento' label = 'Exento' type = 'checkbox' value = {formProducto.exento} onChange = {(e: any) => onChangeFormProducto('exento', !formProducto.exento)}/>
                    }
                        <InputForm disabled = {props.notaRemision} required name = 'conIva' label = 'Incluye IVA' type = 'checkbox' value = {formProducto.conIva} onChange = {(e: any) => onChangeFormProducto('conIva', !formProducto.conIva)}/>
                        {mostrarNoGravadoNoSujeto && (
                            <>
                                <InputForm required name = 'noSujeto' label = 'No sujeto' type = 'checkbox' value = {formProducto.noSujeto} onChange = {(e: any) => onChangeFormProducto('noSujeto', !formProducto.noSujeto)}/>
                                <InputForm required name = 'noGravado' label = 'No Gravado' type = 'checkbox' value = {formProducto.noGravado} onChange = {(e: any) => onChangeFormProducto('noGravado', !formProducto.noGravado)}/>
                            </>
                        )}
                        {!formProducto.exento && !formProducto.noSujeto && !formProducto.noGravado &&
                            <p style={{color: '#019FC5'}}>Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)</p>
                        }
                    </>
                }
                </div>
                <div className="cf-row-inputs">
                    {
                        (productosCatalogo.length > 0 && formProducto.clave)
                        ? (
                        <InputForm 
                            disabled = {props.notaRemision}
                            type = 'select' 
                            options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.servicio, prod))}
                            keyNameText = 'descripcion' 
                            keyNameValue = 'clave' 
                            onChange = {(e: any) => onChangeSelectCatalogoProducto(e.value)} 
                            label = 'Descripción' 
                            value = {formProducto.clave}
                            componentSideLabel = {
                                <CheckBoxFlag
                                    label="Activar texto con formato" 
                                    value={false} 
                                    onChange={() => {
                                    onChangeFormProducto('clave', '');
                                    }}
                                />
                            }
                        />
                        )
                        : (
                            <InputSwitchDescripcion 
                                required
                                disabled = {props.notaRemision} 
                                defaultEnrequecido={esHtmlDescripcion} 
                                className='m text-field w-input' 
                                maxLength = {1000}  
                                name = 'descripcion' 
                                placeholder = 'Descripción' 
                                label = 'Descripción' 
                                type = 'text' 
                                value = {formProducto.descripcion} 
                                error = {errors.descripcion} 
                                onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                onBlur={() => {}}
                            />    
                        )
                    }
                </div>
                <div style={{paddingTop: '20px'}}>
                    <div className={`ef-form-producto-div4`}>
                    <div className='label-input'>
                    <InputForm 
                        maxLength = {15}
                        type = 'text'
                        value = {formProducto.cantidad}
                        name = 'cantidad'
                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                        placeholder = '0'
                        required
                        label = 'Cantidad'
                        error = {errors.cantidad}
                    />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        type = 'select'
                        value = {formProducto.unidadMedida}
                        name = 'unidad'
                        onChange = {(e: any) => onChangeFormProducto('unidadMedida', e.value)}
                        placeholder = 'Unidad de medida'
                        required
                        label = 'Unidad de medida'
                        options = {unidadesMedida}
                        keyNameText='valor'
                        keyNameValue='codigo'
                       />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        maxLength = {15}
                        type = 'text'
                        value = {formProducto.precio}
                        name = 'precio'
                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                        placeholder = 'Precio'
                        required
                        label = 'Precio'
                        error = {errors.precio}
                    />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        type = 'select'
                        value = {formProducto.tipoDescuento}
                        name = 'tipoDesc'
                        onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}
                        placeholder = 'Tipo de desc.'
                        required
                        label = 'Tipo de desc.'
                        options = {[{value: 'Porcentaje'}, {value: 'Monto'}]}
                        keyNameText='value'
                        keyNameValue='value'
                    />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                        leftIcon = {formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                        type = 'text'
                        value = {formProducto.descuento}
                        name = 'descuento'
                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                        placeholder = 'Descuento'
                        label = 'Descuento'
                        error = {errors.descuento}
                    />
                    </div>
                    </div>
                </div>
                {!props.facturaExportacion &&
                <div className="cf-calculos-producto">
                    <table>
                        <tbody>
                            <tr className="cf-subtotal">
                                <td>Valor bruto</td>
                                <td>{isNaN(neto) ? '$0.00' : formatearNum(neto)}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Impuesto al Valor Agregado 13%
                                </td>
                                <td>{isNaN(iva) ? '$0.00' : formatearNum(iva)}</td>
                            </tr>
                            <tr className="cf-subtotal opacity-full-gray">
                                <td>
                                    <Tooltip content='Cálculo de impuestos aplica en el resumen'>
                                        <button className='table-action no-background'>
                                            <img src={HelpIcon} className='help-icon-button' />
                                        </button>
                                    </Tooltip>
                                    Otros impuestos
                                </td>
                                <td>{isNaN(otrosImpuestos) ? '$0.00' : formatearNum(otrosImpuestos)}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Subtotal</td>
                                <td>{isNaN(subtotal) ? '$0.00' : formatearNum(subtotal)}</td>
                            </tr>
                            <tr className="cf-descuento">
                                <td>Descuento</td>
                                <td>{isNaN(descuento) ? '$0.00' : formatearNum(descuento)}</td>
                            </tr>
                            <tr className="cf-total">
                                <td>Total</td>
                                <td>{isNaN(total) ? '$0.00' : formatearNum(total)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="w-layout-hflex button-actions">
                        <button className="button transparent" onClick={onClickCerrarModalEditarProducto}>Cancelar</button>
                        <button className="button" onClick={onClickActualizarProducto}>Actualizar</button>
                    </div>
                </div>
                }
                {props.facturaExportacion &&
                    <div className="cf-calculos-producto">
                    <table>
                        <tbody>
                            <tr className="cf-subtotal">
                                <td>Subtotal</td>
                                <td>{isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-descuento">
                                <td>Descuento</td>
                                <td>{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-total">
                                <td>Total</td>
                                <td>{isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="w-layout-hflex button-actions">
                        <button className="button transparent" onClick={onClickCerrarModalEditarProducto}>Cancelar</button>
                        <button className="button" onClick={onClickActualizarProducto}>Actualizar</button>
                    </div>
                </div>
                }
            </div>
        </ModalBase>
    )
}